import Grid from '../widgets/grid/grid.vue'
import { Models } from '../../assets/ts/models';
const bpmsModel = new Models();
import NewForm from '../forms/newform/newForm.vue';

export default {

    data() {
        return {
            direction: payload.currentLocale.IsRightToLeft,
            columns: [
                {
                    field: "PrincipalId", title: "id", menu: false, hidden: true
                },
                {
                    field: "Code", title: i18n.$t("session_managment.code"), menu: false, hidden: false
                },
                { field: "Title", title: i18n.$t("session_managment.cell_title"), menu: false, hidden: false },
                { field: "SessionTime", title: i18n.$t("session_managment.timeout"), menu: false, hidden: false, editable: true },
            ],
            model: {
                id: "PrincipalId",
                fields: {
                    Code: { editable: false },
                    Title: { editable: false },
                    SessionTime: {
                        editable: true,
                        validation: {
                            validValue: function (input, t) {
                                var n = input.val();
                                if (n == null || n == "") {
                                    input.attr('data-validValue-msg', i18n.$t("session_managment.session_value_can_not_null"));
                                    return false;
                                }
                                if (n == "0" || parseInt(n) > 480) {
                                    input.attr('data-validValue-msg', i18n.$t("session_managment.session_value_is_not_valid"))
                                    return false;
                                }
                                return true;
                            }
                        }
                    }
                }
            },
            reloadGrid: 0,
            principalType: 1,
            saveSession: this.SaveChanges

        }
    },
    computed: {
        additionalParameters() {
            this.reloadGrid++;
            return {
                typeId: this.principalType
            }
        }
    },
    methods: {
        onChange(e) {
            this.reloadGrid++;
        },
        SaveChanges(e) {
            var changedValue = e.model;
            var val = e.values.SessionTime;
            var data = {
                PrincipalId: changedValue.PrincipalId,
                SessionTime: val
            }
            bpmsModel.ChangeSessionTime(data).done(res => {
                return true;
            }).fail((err) => { 
                utils.showAjaxError(err, err.status, true);
                this.reloadGrid++;
            });

        }
    },
    components: {
        Grid,
        NewForm
    }
}
